import { api } from "./client";

export async function submitAnalysis(cnpj: string) {
  return api.post("analysis/submit", { json: { cnpj } }).json<{ jobId: number; companyId: number; status: string; estimatedTime?: string }>();
}

export async function getAnalysisJob(jobId: number) {
  return api.get(`analysis/${jobId}`).json<{ job: Record<string, unknown> & { phasesCompleted: string[]; progress: number } }>();
}

export async function getScore(companyId: number) {
  return api.get(`scores/${companyId}`).json<{ snapshot: Record<string, unknown> }>();
}

export async function getPortfolioScores(sortBy = "score_overall", order = "desc") {
  return api.get("scores/portfolio", { searchParams: { sortBy, order } }).json<{ companies: Record<string, unknown>[] }>();
}

export async function getScoreTrend(companyId: number, period = "30d") {
  return api.get(`scores/${companyId}/trend`, { searchParams: { period } }).json<{ dataPoints: Record<string, unknown>[] }>();
}
